export default __webpack_public_path__ + "static/media/code_of_life.798ee55f.jpg";